import type { ContinentData } from "@/types/configs";

/**
 * Maps continents to their countries and names
 */
export const continents: Record<string, ContinentData> = {
  africa: {
    countries: [
      "af",
      "dz",
      "ao",
      "bj",
      "bw",
      "bf",
      "bi",
      "cv",
      "cm",
      "cf",
      "td",
      "km",
      "cg",
      "cd",
      "ci",
      "dj",
      "eg",
      "gq",
      "er",
      "sz",
      "et",
      "ga",
      "gm",
      "gh",
      "gn",
      "gw",
      "ke",
      "ls",
      "lr",
      "ly",
      "mg",
      "mw",
      "ml",
      "mr",
      "mu",
      "ma",
      "mz",
      "na",
      "ne",
      "ng",
      "rw",
      "st",
      "sn",
      "sc",
      "sl",
      "so",
      "za",
      "ss",
      "sd",
      "tz",
      "tg",
      "tn",
      "ug",
      "zm",
      "zw",
    ],
    name: "Africa",
  },
  asia: {
    countries: [
      "am",
      "az",
      "bh",
      "bd",
      "bt",
      "bn",
      "kh",
      "cn",
      "ge",
      "in",
      "id",
      "ir",
      "iq",
      "il",
      "jp",
      "jo",
      "kz",
      "kw",
      "kg",
      "la",
      "lb",
      "my",
      "mv",
      "mn",
      "mm",
      "np",
      "kp",
      "om",
      "pk",
      "ph",
      "qa",
      "sa",
      "sg",
      "kr",
      "lk",
      "sy",
      "tw",
      "tj",
      "th",
      "tl",
      "tr",
      "tm",
      "ae",
      "uz",
      "vn",
      "ye",
    ],
    name: "Asia",
  },
  europe: {
    countries: [
      "al",
      "ad",
      "at",
      "by",
      "be",
      "ba",
      "bg",
      "hr",
      "cy",
      "cz",
      "dk",
      "ee",
      "fi",
      "fr",
      "de",
      "gr",
      "hu",
      "is",
      "ie",
      "it",
      "xk",
      "lv",
      "li",
      "lt",
      "lu",
      "mt",
      "md",
      "mc",
      "me",
      "nl",
      "mk",
      "no",
      "pl",
      "pt",
      "ro",
      "ru",
      "sm",
      "rs",
      "sk",
      "si",
      "es",
      "se",
      "ch",
      "ua",
      "gb",
      "va",
    ],
    name: "Europe",
  },
  north_america: {
    countries: [
      "ag",
      "bs",
      "bb",
      "bz",
      "ca",
      "cr",
      "cu",
      "dm",
      "do",
      "sv",
      "gd",
      "gt",
      "ht",
      "hn",
      "jm",
      "mx",
      "ni",
      "pa",
      "kn",
      "lc",
      "vc",
      "tt",
      "us",
    ],
    name: "North America",
  },
  south_america: {
    countries: [
      "ar",
      "bo",
      "br",
      "cl",
      "co",
      "ec",
      "fk",
      "gf",
      "gy",
      "py",
      "pe",
      "sr",
      "uy",
      "ve",
    ],
    name: "South America",
  },
  oceania: {
    countries: [
      "au",
      "fj",
      "ki",
      "mh",
      "fm",
      "nr",
      "nz",
      "pw",
      "pg",
      "ws",
      "sb",
      "to",
      "tv",
      "vu",
    ],
    name: "Oceania",
  },
};
